import template from './home-column.html';

const HomeColumnComponent = {
    bindings: {
        icon: '<',
        links: '<',
        title: '<'
    },
    template,
};

export default HomeColumnComponent;



// WEBPACK FOOTER //
// ./app/components/home/home-column/home-column-component.js